var map = {
	"./404.jpeg": 410,
	"./IXP-android-scan-code.png": 265,
	"./acado-logo.png": 865,
	"./activate-user-banner.png": 305,
	"./active-user-qr.png": 866,
	"./aicte-logo.png": 328,
	"./app-store.svg": 867,
	"./appleplay-store.png": 411,
	"./blog_post_detail.png": 868,
	"./brand-logo.png": 869,
	"./brandlogo.png": 870,
	"./bulk_batch_assign.csv": 180,
	"./bulk_password.csv": 382,
	"./bulk_question_create.csv": 392,
	"./bulk_student_create.csv": 381,
	"./cilogo.jpg": 522,
	"./close-arrow.svg": 266,
	"./common-footerQR.png": 412,
	"./contacts-icon.png": 185,
	"./content-lib.png": 137,
	"./content.svg": 384,
	"./courses.svg": 188,
	"./create_group_student.csv": 396,
	"./dialog-close.png": 871,
	"./down-arrow.png": 523,
	"./dps-logo.png": 872,
	"./edulyst-banner.png": 413,
	"./element1.svg": 873,
	"./empty.png": 874,
	"./empty.svg": 378,
	"./error.svg": 524,
	"./exit-screen.svg": 390,
	"./facebook-icon.png": 249,
	"./favicon.ico": 875,
	"./favicon.svg": 876,
	"./full-screen.svg": 389,
	"./googleplay-store.svgz": 195,
	"./grras-logo.png": 877,
	"./home1.svg": 878,
	"./home2.svg": 879,
	"./home3.svg": 880,
	"./home4.svg": 881,
	"./imaginxp-gamebanner.jpg": 882,
	"./imaginxp-loginbanner-1.jpg": 414,
	"./imaginxp-loginbanner-2.jpg": 415,
	"./imaginxp-loginbanner-3.jpg": 416,
	"./imaginxp-loginbanner-4.jpg": 417,
	"./imaginxp-loginbanner-5.jpg": 418,
	"./imaginxp-logo.png": 883,
	"./img-holder.svg": 45,
	"./instagram-icon.png": 251,
	"./learner_blogpost.png": 884,
	"./learnfest-sessions-thumb1.jpg": 419,
	"./learnfest-sessions-thumb10.jpg": 420,
	"./learnfest-sessions-thumb11.jpg": 421,
	"./learnfest-sessions-thumb2.jpg": 422,
	"./learnfest-sessions-thumb3.jpg": 423,
	"./learnfest-sessions-thumb4.jpg": 424,
	"./learnfest-sessions-thumb5.jpg": 425,
	"./learnfest-sessions-thumb6.jpg": 426,
	"./learnfest-sessions-thumb7.jpg": 427,
	"./learnfest-sessions-thumb8.jpg": 428,
	"./learnfest-sessions-thumb9.jpg": 429,
	"./linkedin-icon.png": 250,
	"./login-banner1.jpg": 885,
	"./login-banner2.jpg": 886,
	"./login-banner3.jpg": 887,
	"./login-banner4.jpg": 888,
	"./mark-attendance-icon.png": 383,
	"./model-banner.jpg": 208,
	"./my-percentage-coming-soon-banner.jpg": 398,
	"./noesis.svg": 889,
	"./nothing-to-show.png": 400,
	"./open-arrow.svg": 267,
	"./play-store.svg": 890,
	"./questionoftheday-bg.png": 430,
	"./questionoftheday-header.svg": 525,
	"./referral-rightbg.jpg": 891,
	"./referral-rightbg.png": 892,
	"./referral-rightbg1.png": 893,
	"./reportsCheckBoxTick.png": 894,
	"./sastra-login-banner1.jpg": 895,
	"./sastra-login-banner2.jpg": 896,
	"./sastra-login-banner3.jpg": 897,
	"./sastra-login-banner4.jpg": 898,
	"./sastra-logo.png": 899,
	"./sastra-logo1.png": 900,
	"./scancode-banner.png": 213,
	"./search-icon.png": 901,
	"./searching-page-herobg.jpg": 902,
	"./signup-bg.png": 903,
	"./signup-slider1.png": 904,
	"./signup-slider2.png": 905,
	"./signup-slider3.png": 906,
	"./skyed-logo.png": 907,
	"./sm-lib.svg": 246,
	"./sow-login-banner1.png": 526,
	"./sow-login-banner2.png": 527,
	"./sow-login-banner3.png": 528,
	"./sow-login-banner4.png": 529,
	"./sow-logo.png": 908,
	"./sow-sectio-3shape.svg": 909,
	"./sow-section-2-icon1.png": 910,
	"./sow-section-2-icon2.png": 911,
	"./sow-section-2-icon3.png": 912,
	"./sow-section-2-icon4.png": 913,
	"./sow-section-2bg.svg": 914,
	"./sow-section-3-administration.svg": 915,
	"./sow-section-3-list-bullet.png": 916,
	"./sow-section-3-list-symbol.png": 917,
	"./sow-section-3-list-symbol2.png": 918,
	"./sow-section-3-parents.svg": 919,
	"./sow-section-3-student.svg": 920,
	"./sow-section-3-teacher.svg": 921,
	"./sow-section-4-banner.svg": 922,
	"./sow-section-5-banner.svg": 923,
	"./sow-section-6-banner.svg": 924,
	"./sow-section-7-banner.svg": 925,
	"./sow-section-8-banner.svg": 926,
	"./ugpg-banner.png": 927,
	"./ugpgBanner1.png": 403,
	"./ugpgBanner2.png": 404,
	"./ugpgBanner3.png": 405,
	"./veranda-innovation.png": 928,
	"./veranda-login-banner1.jpg": 929,
	"./veranda-login-banner2.jpg": 930,
	"./veranda-login-banner3.jpg": 931,
	"./veranda-login-banner4.jpg": 932,
	"./veranda-logo.png": 933,
	"./vgu-login-banner1.jpg": 934,
	"./vgu-login-banner1.png": 935,
	"./vgu-login-banner2.jpg": 936,
	"./vgu-login-banner3.jpg": 937,
	"./vgu-login-banner4.jpg": 938,
	"./vgu-logo.jpg": 939,
	"./vgu-logo.png": 940,
	"./vgu-logo1.jpg": 155,
	"./xp-banner1.jpg": 941,
	"./xp-banner2.jpg": 942,
	"./xp-banner3.jpg": 943,
	"./xp-banner4.jpg": 944,
	"./xp-banner5.jpg": 945,
	"./xp-banner6.jpg": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 178;